import copperData from "@data/rogue_5/copper.json"

import MainLoader from "@/components/MainLoader"
// import { getRoguelikeItem } from "@/utils/assets"
import { isMobile } from "@/utils/misc"
import { buildings, useWebM } from "../pages/Lobby/building"

const loadAssets = () => {
    const loader = MainLoader.getInst()

    // buildings
    if (!isMobile()) {
        buildings.forEach((building) => {
            if (!useWebM) {
                loader.load(building.png, false)
            }
        })
    }

    // copper
    loader.load(
        copperData.flatMap((group) =>
            group.items.map(
                (item) =>
                    `${__ASSETS_HOST}assets/img/static/rogue_5/copper/${item.id}.png`
            )
        ),
        false
    )
}

export default loadAssets
